OffersTimer = window.OffersTimer ?= {}
CountdownTimer = window.CountdownTimer ?= {}

CountdownTimer.Helpers = require '../../../groupon-deal-timer/common/helpers'

OFFERS_TIME_EL = "#offers-time-left"

OffersTimer.View = Backbone.View.extend
  UPDATE_FREQUENCY_MS: 1000
  isSoldOut: false

  initialize: ->
    @i18n = @options.i18n

  render: ->
    @$el = $(OFFERS_TIME_EL)
    return if @model.timeLeft()?.millisLeft <= 0
    setInterval (=> @updateCountdown()), @UPDATE_FREQUENCY_MS

  updateCountdown: ->
    return if @isSoldOut
    offersTimer = @model.timeLeft()
    if offersTimer?.millisLeft <= 0
      @isSoldOut = true
      @$el.html @t "js.modules.offers.sold_out"
      @$el.addClass 'sold-out'
      buyUrlHash = @model.buyUrlHash()
      _.each $('.btn-buy-big.buy-button, .options-content tr a'), (element) ->
        if element.href != "#{window.location.href}#"
          originalBuyUrl = buyUrlHash[element.href]
          element.href = originalBuyUrl
    else
      txnKey = CountdownTimer.Helpers.countdownTimeKey offersTimer?.timeLeft
      return unless txnKey
      countdownTime = @t "js.modules.offers#{txnKey}",
        days: offersTimer?.timeLeft?.days
        timestamp: CountdownTimer.Helpers.countdownTimestamp offersTimer?.timeLeft
      @$el.html(countdownTime)

  t: ->
    @i18n.t.apply @i18n, arguments


module.exports = OffersTimer.View
